import { TextBox as TextBoxType } from "store/features/memeGenerator/types";
import { useAppSelector } from "store/store";
import { TextBox } from "./TextBox/TextBox";

interface TextBoxesProps {
    xRatio: number;
    yRatio: number;
}

export const TextBoxes = ({ xRatio, yRatio }: TextBoxesProps) => {
    const textBoxes = useAppSelector((state) => state.memeGenerator.meme?.textBoxes, equalityFn) || [];
    return (
        <>
            {textBoxes.map((textBox) => (
                <TextBoxRenderer key={textBox.id} id={textBox.id} xRatio={xRatio} yRatio={yRatio} />
            ))}
        </>
    );
};

function equalityFn(left: TextBoxType[] | undefined, right: TextBoxType[] | undefined) {
    const leftIds = left?.map((t) => t.id) || [];
    const rightIds = right?.map((t) => t.id) || [];
    return leftIds.every((id, index) => id === rightIds[index]);
}

interface TextBoxRendererProps extends TextBoxesProps {
    id: string;
}

const TextBoxRenderer = ({ id, xRatio, yRatio }: TextBoxRendererProps) => {
    const textBox = useAppSelector((state) => state.memeGenerator.meme?.textBoxes.find((_t) => _t.id === id));
    if (!textBox) return null;
    return (
        <TextBox
            textBox={{
                ...textBox,
                left: textBox.left * xRatio,
                top: textBox.top * yRatio,
                width: textBox.width * xRatio,
                height: textBox.height * yRatio,
                fontSize: textBox.fontSize,
                spacing: {
                    letter: textBox.spacing.letter,
                    line: textBox.spacing.line,
                },
            }}
            xRatio={xRatio}
            yRatio={yRatio}
        />
    );
};
